export default "__VITE_ASSET__DonQU1E___"